import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '../Layout';
import CardDefault from '../Card/Default';
import { StyledList } from './styles';

const List = ({
  className,
  isFullWidth,
  itemWidth,
  itemHeight,
  children,
  cards,
}) => (
  <Container restrict={!isFullWidth}>
    <StyledList
      className={className}
      theme={{
        itemWidth: itemWidth,
        itemHeight: itemHeight,
      }}
    >
      {cards
        ? cards.map(x => (
            <li key={x.key}>
              <CardDefault {...x} />
            </li>
          ))
        : children}
    </StyledList>
  </Container>
);

List.propTypes = {
  children: PropTypes.any,
  cards: PropTypes.arrayOf(PropTypes.object.isRequired),
  className: PropTypes.string,
  isFullWidth: PropTypes.bool,
  itemWidth: PropTypes.number,
  itemHeight: PropTypes.number,
};
List.defaultProps = {
  isFullWidth: false,
  itemWidth: 33,
  itemHeight: 0,
};

export default List;
